import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';
import { ApiChannel } from 'core/constants';
import { StoreAction } from 'store/actions';
import { DeviceEsimTransfer } from './models';
import { EsimOrderStatus } from './models/order-status';

@Injectable()
export class EsimWebsheetApi {
    public static deviceEsimTransfer(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<DeviceEsimTransfer> {        
        return http.post('/lines/devices/esims/transfer', params.payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: ApiResponse) => DeviceEsimTransfer.create<DeviceEsimTransfer>(response))
        );
    }

    public static getEsimOrderStatus(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<EsimOrderStatus> {
        return http.get(`/orders/${params.orderKey}/status`, { headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY }) }).pipe(
            map((response: ApiResponse) => EsimOrderStatus.create<EsimOrderStatus>(response))
        );
    }
}

ModelBase.persistMapping[StoreAction.POST_DEVICE_ESIM_TRANSFER] = EsimWebsheetApi.deviceEsimTransfer;
ModelBase.persistMapping[StoreAction.GET_ESIM_ORDER_STATUS] = EsimWebsheetApi.getEsimOrderStatus;
